import {getCurrentUserId} from '../selectors'
import type {UserId} from '../types'

import {useAppSelector} from './react-redux'

export default function useMyId(): UserId | null | undefined {
  return useAppSelector(getCurrentUserId)
}
